import * as React from 'react';

const SvgSheduleInterview = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.2}
      d="M13 3H11C6.02944 3 2 7.02944 2 12V17C2 19.2091 3.79086 21 6 21H13C17.9706 21 22 16.9706 22 12C22 7.02944 17.9706 3 13 3Z"
      fill="#605AFB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4003 13.5496L15.4016 13.5478C15.6506 13.2183 16.1193 13.152 16.45 13.4C16.7813 13.6485 16.8485 14.1186 16.6 14.45L16.5992 14.451L16.5983 14.4522L16.596 14.4552L16.5898 14.4634L16.5705 14.488C16.5547 14.508 16.5329 14.535 16.5051 14.5681C16.4496 14.6342 16.3703 14.7247 16.268 14.8314C16.064 15.0443 15.7652 15.3254 15.3786 15.6066C14.6083 16.1668 13.4566 16.75 12 16.75C10.5433 16.75 9.39166 16.1668 8.62133 15.6066C8.23472 15.3254 7.93588 15.0443 7.7319 14.8314C7.6296 14.7247 7.55027 14.6342 7.49481 14.5681C7.46706 14.535 7.44521 14.508 7.42938 14.488L7.41013 14.4634L7.40391 14.4552L7.40165 14.4522L7.40073 14.451L7.39995 14.45C7.15143 14.1186 7.21858 13.6485 7.54996 13.4C7.88055 13.1521 8.34921 13.2183 8.5982 13.5477M8.5982 13.5477L8.60544 13.5569C8.61281 13.5662 8.62563 13.5822 8.64377 13.6038C8.68011 13.6471 8.73749 13.7128 8.81488 13.7936C8.97028 13.9557 9.20269 14.1746 9.50358 14.3934C10.1083 14.8332 10.9566 15.25 12 15.25C13.0433 15.25 13.8917 14.8332 14.4963 14.3934C14.7972 14.1746 15.0296 13.9557 15.185 13.7936C15.2624 13.7128 15.3198 13.6471 15.3561 13.6038C15.3743 13.5822 15.3871 13.5662 15.3945 13.5569L15.4016 13.5478L15.4003 13.5496M8.5982 13.5477L8.59881 13.5485L8.59944 13.5493C8.59944 13.5493 8.59808 13.5476 8.60544 13.5569L8.59944 13.5493L8.5982 13.5477Z"
      fill="#605AFB"
    />
  </svg>
);

export default SvgSheduleInterview;
